document.addEventListener('DOMContentLoaded', function() {
  const isTouch = window.matchMedia('(hover: none)').matches;

  /* === REVEAL AU SCROLL === */
  const revealTargets = document.querySelectorAll('[class*="__card"], .ml-card');
  revealTargets.forEach(function(el) { el.classList.add('ml-reveal'); });

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    revealTargets.forEach(function(el) { observer.observe(el); });
  } else {
    revealTargets.forEach(function(el) { el.classList.add('is-visible'); });
  }

  /* === TILT 3D SUR CARTES (desktop uniquement) === */
  if (!isTouch) {
const tiltCards = document.querySelectorAll('[class*="__card"]:not(.ml-pg__card), .ml-card');    tiltCards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const rotateX = ((y - centerY) / centerY) * -4;
        const rotateY = ((x - centerX) / centerX) * 4;
        card.style.transform = 'perspective(800px) rotateX(' + rotateX + 'deg) rotateY(' + rotateY + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = 'perspective(800px) rotateX(0) rotateY(0) translateY(0)';
      });
    });
  }
});